import {stepIconName, stepColor, stepTitle, formatDate} from 'js/lib/planner'
import AgencyLink from './_agency-link'
import template from './_sidepanel-selected-route.pug'

// @vue/component
export default {
  template: template(),
  components: {
    AgencyLink
  },
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    leg() {
      return this.route.leg
    },
    steps() {
      return this.leg.steps
    },
    uniqueAgencies() {
      return this.agencies.filter((agency, index) => index === this.indexOfAgency(agency))
    },
    agencies() {
      return this.steps.map(this.getAgency).filter(Boolean)
    }
  },
  methods: {
    stepIconName,
    stepTitle,
    formatDate,
    stepColor(step) {
      return stepColor(step, {acceptWhite: false})
    },
    getAgency(step) {
      return _.get(step, 'transit.line.agencies[0]')
    },
    indexOfAgency(agency) {
      return this.agencies.findIndex(current => JSON.stringify(agency) === JSON.stringify(current))
    },
    stepTime(step, index) {
      return _.get(step, 'transit.departure_time.text') ||
        _.get(this.leg.steps, `[${index - 1}].transit.arrival_time.text`)
    },
    departureTimeText(leg) {
      return _.get(leg, 'departure_time.text')
    },
    arrivalTimeText(leg) {
      return _.get(leg, 'arrival_time.text')
    }
  }
}
